export enum FundFullDeploymentTrigger {
  Allocation = 'ALLOCATION',
  AllocationPreview = 'ALLOCATION_PREVIEW',
  FundSettings = 'FUND_SETTINGS',
}
